module.exports = __webpack_public_path__ + "img/28.d8207ed3.jpg";